import {Pinia} from 'pinia'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {useDatabaseApiStore} from '@toolify/client/src/stores/api/DatabaseApiStore/useDatabaseApiStore'
import {RouteLocationNormalized} from 'vue-router'
import {useDatabaseViewApiStore} from '@toolify/client/src/stores/api/DatabaseViewApiStore/useDatabaseViewApiStore'
import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {KnownError} from '@toolify/server/src/middleware/ApiResponseMiddleware/types/KnownError'

export function beforeDatabasePageRouterHookFactory(pinia: Pinia) {
  return async function beforeDatabasePageRouterHook(to: RouteLocationNormalized) {
    const databaseApiStore = useDatabaseApiStore()
    const databaseViewApiStore = useDatabaseViewApiStore()
    
    try {
      const [
        getDatabaseResponse,
        getDatabaseViewsResponse,
      ] = await Promise.all([
        databaseApiStore.getDatabase(to.params.databaseId as string),
        databaseViewApiStore.getViews(to.params.databaseId as string),
      ])

      const database = getDatabaseResponse.database
      const databaseViews = getDatabaseViewsResponse.databaseViews
      const lastUserDatabaseViewId = window.localStorage.getItem(`current-view-db-${database.id}`)

      const databaseViewId = lastUserDatabaseViewId && databaseViews.some(view => view.id === lastUserDatabaseViewId)
        ? lastUserDatabaseViewId
        : databaseViews.find(view => view.id === database.defaultDatabaseViewId)?.id
          || databaseViews.find(view => view.position === 0)?.id
          || databaseViews?.[0]?.id

      if(!databaseViewId) {
        return
      }
      return {
        name: RouteName.DatabaseView,
        params: {
          databaseViewId,
          databaseId: database.id,
          workspaceName: to.params.workspaceName,
        },
      }
    } catch (error) {
      if (error instanceof ApiException && [KnownError.NotFound, KnownError.NoPermissions].includes(error.name)) {
        return
      }
      throw error
    }
  }
}
